import React, { Fragment } from "react";
import {
  Table,
  TableBody,
  TableRow,
  FormControlLabel,
  Button,
  Checkbox,
  FormGroup,
  Typography,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
function ViewResult(props) {
  const FontTableCell = props.FontTableCell;
  return (
    <Fragment>
      <Table>
        <TableBody>
          <TableRow>
            <FontTableCell width="35%">
              개인정보
              <br />
              수집 항목
            </FontTableCell>
            <FontTableCell>수집 목적</FontTableCell>
            <FontTableCell>보유 및 이용기간</FontTableCell>
          </TableRow>

          <TableRow>
            <FontTableCell>
              *필수 항목
              <br />: 성명, 성별, 휴대폰번호, 생년월일
            </FontTableCell>
            <FontTableCell rowSpan={2}>
              *멤버십 서비스에 따른 본인 확인 및 멤버십 포인트 적립 / 사용
              절차에 이용
              <br />
              *상품, 이벤트, 서비스 등의 정보제공(SMS,카카오톡 등)
              <br />
              *사은품, 경품, 할인쿠폰 등의 제공
              <br />
              *통계자료 작성 및 서비스 개발을 위한 자료 작성
            </FontTableCell>
            <FontTableCell rowSpan={2}>
              (주)신원 특판 멤버십회원 탈퇴시 까지
            </FontTableCell>
          </TableRow>
          <TableRow>
            <FontTableCell>
              *선택 항목
              <br />: 주소, 추천인 휴대폰번호, 행사장 방문 경로
            </FontTableCell>
          </TableRow>
        </TableBody>
      </Table>
      <hr />
    </Fragment>
  );
}
function Personal(props) {
  const FontTableCell = props.FontTableCell;
  const classes = props.useStyles();
  const [showResults, setShowResults] = React.useState(false);
  const onView = (e) => {
    e.preventDefault();
    setShowResults(!showResults);
  };
  return (
    <>
      <FormGroup row>
        <FormControlLabel
          inputRef={props.personalRef}
          control={
            <Checkbox
              checked={props.personal}
              onChange={(e) => {
                props.onChangePersonal(e.target.checked);
              }}
              name="personal"
            />
          }
          label={
            <Typography className={classes.TypographyFont}>
              [필수]개인정보 수집, 활용 동의서
            </Typography>
          }
        />
        <Button
          className={classes.Button}
          variant="text"
          color="primary"
          type="submit"
          onClick={onView}
          startIcon={<VisibilityIcon />}
        >
          내용보기
        </Button>
      </FormGroup>

      <hr />
      {showResults ? <ViewResult FontTableCell={FontTableCell} /> : null}
    </>
  );
}
export default Personal;
